import React from 'react';
import {
  maskedModeSelectors,
  maskedModeActions,
} from '../../redux/modules/maskedMode';
import { projectPickerSelectors } from '../../redux/modules/projectPicker';
import MaskedModeSwitch, { MaskedModeSwitchOwnProps } from './MaskedModeSwitch';
import { RootState } from '../../redux/rootReducer';
import { connect } from 'react-redux';

export interface MaskedModeSwitchContainerStateProps
  extends Pick<MaskedModeSwitchOwnProps, 'isActive' | 'isForced'> {
  activeProjectId?: string;
}

export type MaskedModeSwitchContainerDispatchProps = Pick<
  MaskedModeSwitchOwnProps,
  'setMaskedMode'
>;

export type MaskedModeSwitchContainerProps =
  MaskedModeSwitchContainerStateProps & MaskedModeSwitchContainerDispatchProps;

export class MaskedModeSwitchContainer extends React.Component<MaskedModeSwitchContainerProps> {
  public componentDidUpdate(prevProps: MaskedModeSwitchContainerProps) {
    if (prevProps.activeProjectId !== this.props.activeProjectId) {
      this.props.setMaskedMode(true);
    }
  }

  public render() {
    const { activeProjectId, ...maskedModeSwitchProps } = this.props;
    return <MaskedModeSwitch {...maskedModeSwitchProps} />;
  }
}

const mapStateToProps = (
  state: RootState,
): MaskedModeSwitchContainerStateProps => ({
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  activeProjectId: projectPickerSelectors.selectActiveProjectId(state),
  isActive: maskedModeSelectors.selectShouldMask(state),
  isForced: maskedModeSelectors.selectMaskForced(state),
});

const mapDispatchToProps: MaskedModeSwitchContainerDispatchProps = {
  setMaskedMode: maskedModeActions.setMaskedMode,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MaskedModeSwitchContainer);
